import { supabase } from '../lib/supabase'

// Solo lectura: las ACLE las registra el propio socio desde el Portal Socio.
export async function obtenerAclesDeSocio(organizacionId, socioId) {
  const { data: relations, error } = await supabase
    .from('cp_socio_acles')
    .select('acle_id')
    .eq('organizacion_id', organizacionId)
    .eq('socio_id', socioId)
  if (error) throw new Error('No fue posible cargar las actividades ACLE.')
  if (!relations?.length) return []

  const { data: acles, error: aclesError } = await supabase
    .from('cp_acles')
    .select('id, nombre, orden')
    .eq('organizacion_id', organizacionId)
    .in('id', relations.map((relation) => relation.acle_id))
    .order('orden')
    .order('nombre')
  if (aclesError) throw new Error('No fue posible cargar las actividades ACLE.')
  return acles ?? []
}
